<base-infopage [staticMapInput]="staticMapInput()">
    @if(stockCooperativeInfoIsLoading()){
    <div class="loader">
        <ev-logo-loader width="70px" />
    </div>

    } @else if (stockCooperativeInfoError()){
    <div>Klarte ikke å laste inn aksjelaget {{ stockCooperativeInfoError() }}</div>
    }@else{
    <!-- <infopage-address-header [keyInfo]="stockCooperativeInfo()" [navigationMenuItems]="null"></infopage-address-header> -->
    <key-info [keyInfoData]="stockCooperativeInfo()" [imagePackages]="imagePackages()"
        [physicalExposures]="physicalExposures()">
    </key-info>

    <div class="accordions">
        <infopage-accordion [accordionState]="buildingAccordionStateClass">
            <buildings [propertyInformation]="buildingAccordionStateClass.data()"></buildings>
        </infopage-accordion>
        <infopage-accordion [accordionState]="publicAddressInfoAccordionStateClass">
            <public-address-info [addressInfo]="publicAddressInfoAccordionStateClass.data()"></public-address-info>
        </infopage-accordion>
        <infopage-accordion [accordionState]="unitSharesAccordionStateClass">
            <unit-shares [unitShares]="unitSharesAccordionStateClass.data()"></unit-shares>
        </infopage-accordion>
        <infopage-accordion [accordionState]="shareSalesAccordionStateClass">
            <share-sales [shareSales]="shareSalesAccordionStateClass.data()" [unitId]="unitId()"></share-sales>
        </infopage-accordion>
    </div>
    }
</base-infopage>
